<template>
  <v-file-input
    :rules="rules"
    v-bind="fieldProps"
    name="attachment"
    label="Currículum (.pdf, .doc ou .docx)"
    accept=".doc,.docx,.pdf"
  ></v-file-input>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { curriculumValidation } from "../validations/curriculumValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [
      requiredValidation("Selecione seu currículum."),
      curriculumValidation(),
    ],
  }),
  mixins: [mixin],
};
</script>
